import React from 'react';

import { css, cx } from '@emotion/css';

import { usePatientFromURL } from '@/hooks/usePatientIdFromURL.ts';
import { useStyles } from '@/hooks/useStyles.ts';
import { Queries } from '@/queries/Queries.ts';
import { Theme } from '@/theme/CreateTheme.ts';
import { AlertsButton } from '@/uiKit/molecules/PatientNavigation/AlertsButton.tsx';
import { NurseNoticeButton } from '@/uiKit/molecules/PatientNavigation/NurseNoticeButton.tsx';
import { PhoneButton } from '@/uiKit/molecules/PatientNavigation/PhoneButton.tsx';
import { RenewalButton } from '@/uiKit/molecules/RenewalButton.tsx';

export type PatientActionsProps = {
  className?: string;
};

export const PatientActions: React.FC<PatientActionsProps> = ({
  className,
}) => {
  const styles = useStyles(makeStyles);
  const patient = usePatientFromURL();
  const me = Queries.user.usePractitionerMe({});
  const isNurse = me.qualification === 'nurse';
  const isDoctor = me.qualification === 'doctor';

  return (
    <div className={cx(styles.container, className)}>
      {isNurse && <PhoneButton patientId={patient.id} />}
      <AlertsButton patientId={patient.id} />
      {isNurse && <NurseNoticeButton patientId={patient.id} />}
      {isDoctor && (
        <RenewalButton data-source="header" patientId={patient.id} />
      )}
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(12),
  }),
});
